import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ScreenContainer from 'components/containers/ScreenContainer';
import CreateIcon from 'components/icons/CreateIcon';
import UserTable from 'components/UserTable';
import useIsAppUsers from 'hooks/useIsAppUsers';

function Users() {
	const { t } = useTranslation();

	const navigate = useNavigate();

	const isAppUsers = useIsAppUsers();

	return (
		<ScreenContainer title={t(isAppUsers ? 'common:app_user_plural' : 'common:panel_user_plural')}>
			{!isAppUsers && <CreateIcon onCreate={() => navigate('/panel/users/new')} />}

			<UserTable />
		</ScreenContainer>
	);
}

export default Users;
